import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxVoucher from '../util/remote/ajaxVoucher';
import { type } from '@testing-library/user-event/dist/type';

const initialState = { 
  voucherStats: {
      active: 0,
      redeemedToday: 0,
      revenueToday: 0,
      expiringSoon: 0,
      walletConnected: false,
    },
    statsLoaded: false,
    transactions: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    salesSummary: null,
    vendors: null,
};


const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const SalesContext = createContext();

const defaultFilters = { 
  start_date: '', 
  end_date: '', 
  plan_id: '', 
  status: '', 
  source: '', 
  router_id: '', 
  created_by: '', 
  payment_status: '', 
  msisdn: '' 
};

export const SalesProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [filters, setFilters] = useState(defaultFilters);

  useEffect(()=>{
      if(state.mounted){
        getSalesBreakdown(false, true);
      }
    }, [state.currentPage, state.mounted])

  
  const getSalesBreakdown = async (refresh = false, nextPage = false) => {
    if(!refresh && Array.isArray(state.transactions) && !nextPage) return;
    if(refresh){
        setCurrentPage(1);
        dispatch({ type: 'transactions', payload: null });
        dispatch({ type: 'metaData', payload: null });
    }
    const server_response  = await ajaxVoucher.fetchSalesBreakdown({ page: refresh ? 1 : state.currentPage, filters });
    if(server_response.status === "OK"){
        dispatch({ type: 'transactions', payload: server_response.details.data });
        dispatch({ type: 'metaData', payload: server_response.details.meta });
    }else{
        dispatch({ type: 'transactions', payload: '404' });
        dispatch({ type: 'metaData', payload: null });
    }
  };

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setMounted = (value) => {
    dispatch({ type: 'mounted', payload: value });
  };

  const getSalesSummary = async (refresh = false) => {
    if (!refresh && state.salesSummary) return;
    if(refresh){
      dispatch({ type: 'salesSummary', payload: null });
    }
    const server_response = await ajaxVoucher.fetchSalesSummary({filters});
    if (server_response.status === "OK") {
      dispatch({ type: 'salesSummary', payload: server_response.details });
      setFilters(server_response.details.filters || defaultFilters);
    }else{
      dispatch({ type: 'salesSummary', payload: '404' });
    }
  };

  const getVendors = async (refresh = false) => {
    if (!refresh && state.vendors) return;
    const server_response = await ajaxVoucher.fetchVendors();
    if (server_response.status === "OK") {
      dispatch({ type: 'vendors', payload: server_response.details });
    }else{
      dispatch({ type: 'vendors', payload: '404' });
    }
  };

  

  return(
    <SalesContext.Provider value={{
      ...state,
      filters,
      defaultFilters,
      setFilters,
      dispatch,
      getSalesBreakdown,
      setCurrentPage ,
      setMounted,
      getSalesSummary,
      getVendors,
      }}>
      {children}
    </SalesContext.Provider>
  )

}

export const useSales = ()=>useContext(SalesContext);
